var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuth0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1228_2916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.466 0.100586H10.7184L13.127 7.56725H20.8746L14.6123 12.0232L17.0209 19.53C21.0352 16.5995 22.3599 12.1436 20.8746 7.56725L18.466 0.100586ZM0.602234 7.56725H8.3499L10.7585 0.100586H2.97069L0.602234 7.56725C-0.883071 12.1436 0.401517 16.5995 4.456 19.53L6.8646 12.0232L0.602234 7.56725ZM4.456 19.53L10.7184 23.9457L16.9807 19.53L10.7184 14.9938L4.456 19.53Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1228_2916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6774,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth0);
export default __webpack_public_path__ + "static/media/auth0.85db9acc.svg";
export { ForwardRef as ReactComponent };